<div class="flex-header mat-dialog-title" translate>
  Add Document
</div>
<div class="flex-content">
  <form [formGroup]="addDocumentForm" #formDir="ngForm">
    <div>
      <tyl-form-field #fileCategoryInput [errorMessage]="fileCategoryErrorMessage" label="Category" class="selectField" style="width: 100%">
        <mat-select aria-label="Category" id="selectCategory" formControlName="fileCategory" required>
          <mat-option *ngFor="let category of portfolioCategories" [value]="category.StuPortCategory_ID" translate>{{category.StuPortCategoryName}}</mat-option>
        </mat-select>
      </tyl-form-field>
    </div>
    <div>
      <tyl-form-field [errorMessage]="fileCategoryErrorMessage" label="Description" style="width: 100%">
        <input matInput aria-label="Description" id="documentDescription" formControlName="fileDescription" type="text" required>
      </tyl-form-field>
    </div>
  </form>
  <div style="padding-bottom: 10px">
    <add-file [buttonLabel]="'Browse'" [required]="true" (changes)="addFileChanges($event)"></add-file>
    <div *ngIf="fileError == true" style="color: #b71c1c; font-size: 75%; padding-left: 10px" translate>
      Please select a file
    </div>
  </div>
</div>
<div class="flex-footer">
  <div class="flex-footer-right">
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
  </div>
</div>
